import React, { memo } from 'react';
import './PreviewArtworkWaveform.css';

const pulseDots = [];
for (let column = 0; column < 40; column++) {
  const t = column / 39;
  const firstCrest = 3 * Math.exp(-Math.pow((t - .27) / .16, 2));
  const secondCrest = 10.5 * Math.exp(-Math.pow((t - .74) / .11, 2));
  const rowCount = Math.round(1 + firstCrest + secondCrest);
  for (let row = 0; row < rowCount; row++) {
    pulseDots.push({
      x: t * 304 + 3,
      y: 51 - row * 4,
      opacity: (.20 + .28 * (1 - row / rowCount)) * (.55 + .45 * Math.sin(Math.PI * t)),
    });
  }
}

const PreviewArtworkWaveform = memo(() => (
  <svg className='previewFallbackPulse' viewBox='0 0 310 54' preserveAspectRatio='none' aria-hidden='true' focusable='false'>
    {pulseDots.map((dot, index) => <circle key={index} cx={dot.x} cy={dot.y} r='1' fill='currentColor' opacity={dot.opacity} />)}
  </svg>
));

export default PreviewArtworkWaveform;
